module.exports = __webpack_public_path__ + "static/PCWX.4ce0a900.png";